export default "__VITE_ASSET__DFTRdlDf__"